import state from './modulePaymentMethodTypeState.js'
import mutations from './modulePaymentMethodTypeMutations.js'
import actions from './modulePaymentMethodTypeActions.js'
import getters from './modulePaymentMethodTypeGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
